import PaymentJournalApi from '../PaymentJournalApi';
import * as types from './ActionTypes';

function getPaymentJournalListSuccess(result: any) {
    return { type: types.GET_PAYMENT_LOG_LIST, result: result };
}

export function getPaymentJournalList() {
    return (dispatch: (result: any) => void) =>
        PaymentJournalApi.getPaymentJournalList().then((result: any) => {
            dispatch(getPaymentJournalListSuccess(result));
        });
}

function getPaymentJournalSuccess(result: any) {
    return { type: types.GET_PAYMENT_LOG, result: result };
}

export function getPaymentJournal(id: number) {
    return (dispatch: (result: any) => void) =>
        PaymentJournalApi.getPaymentJournal(id).then((result: any) => {
            dispatch(getPaymentJournalSuccess(result));
        });
}

function createPaymentJournalSuccess(result: any) {
    return { type: types.CREATE_PAYMENT_LOG, result: result };
}

export function createPaymentJournal(legalEntityId: number, site: number) {
    return (dispatch: (result: any) => void) =>
        PaymentJournalApi.createPaymentJournal(legalEntityId, site).then((result: any) => {
            result.legalEntityId = legalEntityId;
            result.site = site;
            dispatch(createPaymentJournalSuccess(result));
        });
}
